import { render, staticRenderFns } from "./DateTimezoneInfo.vue?vue&type=template&id=89dced24&"
import script from "./DateTimezoneInfo.vue?vue&type=script&lang=ts&"
export * from "./DateTimezoneInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports